/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Enum generated from HubAPI C# code.
export enum ApplicationPaymentActivityTypeEnum {
  ExtraHire = 1,
  Handover = 2,
  VariationNewStructure = 3,
  VariationExistingStructure = 4,
  OffHire = 5,
  OngoingHire = 6,
  DiaryEntry = 7,
  Inspection = 8,
  ScaffoldDiaryEntry = 9,
  SiteDiaryEntry = 10,
}
